//Reducers
import generalReducer from './generalReducer';


export default {
    general : generalReducer,
};